export const PLANS = {
  binary: "BINARY",
  uniLevel: "UNILEVEL",
  matrix: "MATRIX",
  roi: "ROI",
  monoLine: "MONOLINE",
};
